<app-loader></app-loader>
<app-banner></app-banner>
@if (logged) {
    <app-announcements-modal [announcements]="announcements()"></app-announcements-modal>
}

<eui-app [isSidebarHidden]="true">
    <eui-app-breadcrumb class="print-not">
        <eui-breadcrumb>
            <eui-breadcrumb-item
                label="{{ 'toolbar.home' | translate }}"
                link="/"
            ></eui-breadcrumb-item>
            @for (item of breadcrumbs$ | async; track item) {
                @if (item.label !== "toolbar.search") {
                    <eui-breadcrumb-item
                        [id]="item.id"
                        [link]="item.link"
                        [label]="item.label | translate"
                    >
                    </eui-breadcrumb-item>
                }
            }
        </eui-breadcrumb>
    </eui-app-breadcrumb>
    @if (showHeader) {
        <eui-app-header class="print-not">
            <eui-header>
                <eui-header-logo></eui-header-logo>
                @if (!isMobile) {
                    <eui-header-environment>{{ config.environmentLabel }}</eui-header-environment>
                }
                <eui-header-app>
                    <eui-header-app-name>RASFF Window</eui-header-app-name>
                    @if (config.environmentLabel) {
                        <eui-header-app-subtitle>
                            BRANCH:
                            {{ environment.branch }}</eui-header-app-subtitle
                        >
                    }
                </eui-header-app>
                <eui-header-right-content>
                    @if (logged) {
                        <button
                            type="button"
                            euiButton
                            euiIconButton
                            euiBasicButton
                            euiRounded
                            [attr.aria-label]="
                                ('header.announcements.modal' | translate) +
                                ' ' +
                                announcements()?.length +
                                ' ' +
                                ('header.announcements.title' | translate)
                            "
                            [attr.aria-describedby]="'announcements-count'"
                            (click)="announcementModal.openDialog()"
                        >
                            <eui-icon-svg
                                aria-hidden="true"
                                icon="eui-megaphone:eui"
                                size="l"
                                (click)="announcementModal.openDialog()"
                            >
                                <eui-badge euiPrimary euiSizeS>{{
                                    announcements()?.length
                                }}</eui-badge>
                            </eui-icon-svg>
                        </button>
                    }
                </eui-header-right-content>
                <eui-header-right-content>
                    <eui-user-profile
                        welcomeLabel="{{ 'header.welcome' | translate }}"
                        [attr.aria-label]="'header.user.profile' | translate"
                    >
                        <eui-user-profile-menu>
                            <eui-user-profile-menu-item
                                class="eui-user-profile-menu-item"
                                role="menuitem"
                                [attr.aria-label]="
                                    logged
                                        ? ('header.logout' | translate)
                                        : ('header.login' | translate)
                                "
                                (click)="toggleLog()"
                                (keydown.enter)="toggleLog()"
                                (keydown.space)="toggleLog()"
                                tabindex="0"
                            >
                                @if (logged) {
                                    <eui-icon-svg
                                        aria-hidden="true"
                                        icon="eui-sign-out"
                                    ></eui-icon-svg>
                                    <span>{{ "header.logout" | translate }}</span>
                                } @else {
                                    <eui-icon-svg
                                        aria-hidden="true"
                                        icon="ecl-log-in:ecl"
                                    ></eui-icon-svg>
                                    <span>{{ "header.login" | translate }}</span>
                                }
                            </eui-user-profile-menu-item>
                        </eui-user-profile-menu>
                    </eui-user-profile>
                </eui-header-right-content>
                <eui-header-right-content>
                    <eui-language-selector></eui-language-selector>
                </eui-header-right-content>
            </eui-header>
        </eui-app-header>
    }

    @if (showToolBar && !isMobile) {
        <eui-app-toolbar class="print-not">
            <eui-toolbar>
                <eui-toolbar-logo></eui-toolbar-logo>
                @for (lang of menuRenderKeys(); track lang) {
                    <eui-toolbar-mega-menu [items]="menuItems()"></eui-toolbar-mega-menu>
                }
            </eui-toolbar>
        </eui-app-toolbar>
    }
    <eui-app-sidebar>
        <eui-app-sidebar-drawer [isExpanded]="showLogOutIn">
            <p
                class="eui-user-profile-menu-item"
                (click)="toggleLog()"
                (keydown.enter)="toggleLog()"
                tabindex="0"
            >
                @if (logged) {
                    <eui-icon-svg aria-hidden="true" icon="eui-sign-out"></eui-icon-svg>
                    {{ "header.logout" | translate }}
                } @else {
                    <eui-icon-svg aria-hidden="true" icon="ecl-log-in:ecl"></eui-icon-svg>
                    {{ "header.login" | translate }}
                }
            </p>
        </eui-app-sidebar-drawer>
        <eui-app-sidebar-header>
            @if (logged && isMobile) {
                <button
                    euiButton
                    euiIconButton
                    euiBasicButton
                    euiRounded
                    [attr.aria-label]="'header.announcements.modal' | translate"
                >
                    <eui-icon-svg
                        aria-hidden="true"
                        icon="megaphone:eui"
                        size="m"
                        (click)="announcementModal.openDialog()"
                    >
                        <eui-badge euiPrimary euiSizeS>{{ announcements()?.length }}</eui-badge>
                    </eui-icon-svg>
                </button>
            }
            <eui-app-sidebar-header-user-profile
                hasProfileDrawer="true"
                (toggle)="showLogOutIn = !showLogOutIn"
            >
            </eui-app-sidebar-header-user-profile>
        </eui-app-sidebar-header>
        <eui-app-sidebar-body>
            @for (lang of menuRenderKeys(); track lang) {
                <eui-app-sidebar-menu [items]="sideBarMenuItems()"></eui-app-sidebar-menu>
            }
        </eui-app-sidebar-body>
        <eui-app-sidebar-footer>
            {{ "sidebar.version" | translate }} {{ environment.version }}
        </eui-app-sidebar-footer>
    </eui-app-sidebar>
    @if (showFooter) {
        <eui-app-footer class="print-not">
            <footer class="ecl-site-footer" data-logo-area-label-en="Home - European Commission">
                <div class="ecl-site-footer__main">
                    <div class="ecl-container ecl-site-footer__container">
                        <div class="ecl-site-footer__row ecl-site-footer__row--specific">
                            <div
                                class="ecl-site-footer__section ecl-site-footer__section--site-info"
                            >
                                <a
                                    href="https://commission.europa.eu/index_en"
                                    class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__logo-link"
                                    ><picture class="ecl-picture ecl-site-footer__picture"
                                        ><img
                                            class="ecl-site-footer__logo-image"
                                            src="https://commission.europa.eu/themes/contrib/oe_theme/dist/ec/images/logo/negative/logo-ec--en.svg"
                                            alt="European Commission logo" /></picture
                                ></a>
                                <div class="ecl-site-footer__description">
                                    <p class="ecl-site-footer__title">
                                        {{ "footer.dg.title" | translate }}
                                    </p>
                                </div>
                            </div>
                            <div class="ecl-site-footer__section ecl-site-footer__section--core">
                                <ul class="ecl-site-footer__list">
                                    <li class="ecl-site-footer__list-item">
                                        <a
                                            href="https://commission.europa.eu/about-european-commission/departments-and-executive-agencies/health-and-food-safety_en"
                                            target="_blank"
                                            class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                            data-section-label-untranslated="Contact us"
                                            data-footer-link-label="Contact Us"
                                            >{{ "footer.dg.contactDG" | translate }}</a
                                        >
                                    </li>
                                    <li class="ecl-site-footer__list-item">
                                        <a
                                            routerLink="/screen/accessibility"
                                            class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                            data-section-label-untranslated="More about us"
                                            data-footer-link-label="Accessibility"
                                            >{{ "footer.dg.accessibility" | translate }}</a
                                        >
                                    </li>
                                    <li class="ecl-site-footer__list-item">
                                        <a
                                            href="https://webgate.ec.europa.eu/tracesnt/privacy-statement"
                                            target="_blank"
                                            class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                            data-section-label-untranslated="More about us"
                                            data-footer-link-label="Privacy Statement"
                                            >{{ "footer.dg.privacy" | translate }}</a
                                        >
                                    </li>
                                    <li class="ecl-site-footer__list-item">
                                        <a
                                            routerLink="/screen/support"
                                            class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                            data-section-label-untranslated="More about us"
                                            data-footer-link-label="IRASFF Support"
                                            >{{ "footer.dg.contactSupport" | translate }}</a
                                        >
                                    </li>
                                </ul>
                            </div>
                            <!-- <div class="ecl-site-footer__column">
                            <div class="ecl-site-footer__section">
                                <p class="ecl-site-footer__title">{{ 'footer.dg.contactUs' | translate }}</p>
                                <ul class="ecl-site-footer__list">
                                    <li class="ecl-site-footer__list-item">
                                        <a
                                            href="https://commission.europa.eu/about-european-commission/departments-and-executive-agencies/health-and-food-safety_en"
                                            target="_blank"
                                            class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                            data-section-label-untranslated="Contact us"
                                            data-footer-link-label="Contact Us"
                                            >{{ 'footer.dg.contactDG' | translate }}</a
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div> -->
                            <!-- <div class="ecl-site-footer__column">
                            <div class="ecl-site-footer__section">
                                <p class="ecl-site-footer__title">{{ 'footer.dg.aboutUs' | translate }}</p>
                                <ul class="ecl-site-footer__list">
                                    <li class="ecl-site-footer__list-item">
                                        <a
                                            routerLink="/screen/accessibility"
                                            target="_blank"
                                            class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                            data-section-label-untranslated="More about us"
                                            data-footer-link-label="Accessibility"
                                            >{{ 'footer.dg.accessibility' | translate }}</a
                                        >
                                    </li>
                                    <li class="ecl-site-footer__list-item">
                                        <a
                                            href="https://webgate.ec.europa.eu/tracesnt/privacy-statement"
                                            target="_blank"
                                            class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                            data-section-label-untranslated="More about us"
                                            data-footer-link-label="Privacy Statement"
                                            >{{ 'footer.dg.privacy' | translate }}</a
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div> -->
                        </div>
                        <div class="ecl-site-footer__row ecl-site-footer__row--common">
                            <ul class="ecl-site-footer__list ecl-site-footer__list--inline">
                                <li class="ecl-site-footer__list-item">
                                    <a
                                        href="https://commission.europa.eu/about-european-commission/contact_en"
                                        target="_blank"
                                        class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                        data-section-label-untranslated="service_navigation"
                                        data-footer-link-label="Contact the European Commission"
                                        >{{ "footer.ec.contact" | translate }}</a
                                    >
                                </li>
                                <li class="ecl-site-footer__list-item">
                                    <a
                                        href="https://european-union.europa.eu/contact-eu/social-media-channels_en#/search?page=0&amp;institutions=european_commission"
                                        target="_blank"
                                        class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                        data-section-label-untranslated="service_navigation"
                                        data-footer-link-label="Follow the European Commission on social media"
                                        >{{ "footer.ec.follow" | translate }}</a
                                    >
                                </li>
                                <li class="ecl-site-footer__list-item">
                                    <a
                                        href="https://commission.europa.eu/resources-partners_en"
                                        target="_blank"
                                        class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                        data-section-label-untranslated="service_navigation"
                                        data-footer-link-label="Resources for partners"
                                        >{{ "footer.ec.partners" | translate }}</a
                                    >
                                </li>
                                <li class="ecl-site-footer__list-item">
                                    <a
                                        href="https://commission.europa.eu/legal-notice/vulnerability-disclosure-policy_en"
                                        target="_blank"
                                        class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                        data-section-label-untranslated="service_navigation"
                                        data-footer-link-label="Report an IT vulnerability"
                                        >{{ "footer.ec.vulnerability" | translate }}</a
                                    >
                                </li>
                                <li class="ecl-site-footer__list-item">
                                    <a
                                        href="https://commission.europa.eu/languages-our-websites_en"
                                        target="_blank"
                                        class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                        data-section-label-untranslated="legal_navigation"
                                        data-footer-link-label="Languages on our websites"
                                        >{{ "footer.ec.languages" | translate }}</a
                                    >
                                </li>
                                <li class="ecl-site-footer__list-item">
                                    <a
                                        href="https://commission.europa.eu/cookies_en"
                                        target="_blank"
                                        class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                        data-section-label-untranslated="legal_navigation"
                                        data-footer-link-label="Cookies"
                                        >{{ "footer.ec.cookies" | translate }}</a
                                    >
                                </li>
                                <li class="ecl-site-footer__list-item">
                                    <a
                                        href="https://commission.europa.eu/privacy-policy_en"
                                        target="_blank"
                                        class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                        data-section-label-untranslated="legal_navigation"
                                        data-footer-link-label="Privacy policy"
                                        >{{ "footer.ec.privacy" | translate }}</a
                                    >
                                </li>
                                <li class="ecl-site-footer__list-item">
                                    <a
                                        href="https://commission.europa.eu/legal-notice_en"
                                        target="_blank"
                                        class="ecl-link ecl-link--standalone ecl-link--inverted ecl-site-footer__link"
                                        data-section-label-untranslated="legal_navigation"
                                        data-footer-link-label="Legal notice"
                                        >{{ "footer.ec.legal" | translate }}</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </eui-app-footer>
    }
</eui-app>
